import { api } from "../Api";
import i18n from "../../Config/i18n.js";

/**
 * Classe que faz as requisições das permissões
 */
export class PermissionsRequests {
    /**
     * Faz a requisição para pegar a permissão
     * @param {string} id da permissão
     */
    async getPermission(id: string):Promise<any>{
        try {
            const response = await api.get(`/permissions/${id}`);
            return response;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para editar a permissão
     * @param id id da permissão a ser editada
     * @param Body informações a serem editadas
     * method-spoofing
     */
    async editPermission(id : string, Body: FormData):Promise<any>{
        try {
            const response = await api.patch(`/permissions/${id}`, Body,{
                headers: {'Accept': 'multipart/form-data', "Content-Type": "multipart/form-data"},
            });
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para pegar todas as permissões
     */
    async getAllPermissions(search: string, page: number):Promise<any>{
        try {
            let response = {
                data: []
            }
            let per_page = 20;
            if(page && search){
                response = await api.get(`/permissions?per_page=${per_page}&search=${search}&page=${page}`);
            }else if(page){
                response = await api.get(`/permissions?per_page=${per_page}&page=${page}`);
            }else{
                response = await api.get(`/permissions?per_page=${per_page}&search=${search}`);
            }
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para criação da permissão
     * @param Body informações da permissão
     * method-spoofing
     */
    async createPermission(Body: FormData):Promise<any>{
        try {
            const response = await api.post(`/permissions`, Body);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    /**
     * Faz a requisição para excluir a permissão
     * @param id id do usuário a ser excluido
     */
    async deletePermission(id: string):Promise<any>{
        try {
            const response = await api.delete(`/permissions/${id}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }
}